import { basicPath } from '../basicPath';

// Helper function to get the correct API path prefix based on domain
const getPaymentsPath = (endpoint) => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const prefix = hostname.includes('readingplex') ? '/rp' : '/mp';
    return endpoint ? `${prefix}/payments/${endpoint}` : `${prefix}/payments`;
};

export const fetchPaymentsContractIds = (params) => async (dispatch) => {
    const path = getPaymentsPath('contract-ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchPaymentsDaterangeCenter = (params) => async (dispatch) => {
    const path = getPaymentsPath('daterange-center');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const fetchPaymentsIds = (params) => async (dispatch) => {
    const path = getPaymentsPath('ids');
    const type = 'get';
    return await basicPath(dispatch, params, path, type);
}

export const createPayment = (params) => async (dispatch) => {
    const path = getPaymentsPath();
    const type = 'post';
    return await basicPath(dispatch, params, path, type);
}

export const updatePayment = (params) => async (dispatch) => {
    const path = getPaymentsPath();
    const type = 'put';
    return await basicPath(dispatch, params, path, type);
}

export const deletePayment = (params) => async (dispatch) => {
    const path = getPaymentsPath();
    const type = 'delete';
    return await basicPath(dispatch, params, path, type);
}